import ApiService from './ApiService'

const TokenService = {
    create(user, name) {
        return ApiService.post('token.store', {}, { user, name })
    },

    revoke(token, for_user) {
        return ApiService.get('token.revoke', { token, for_user })
    },
}

export default TokenService
